module.exports = __webpack_public_path__ + "media/images/icons/twotone/schedule-96f4d7d976aac31ae3b326719aed1204.svg";